var map = {
	"./cursed_finger.mp4": 1859,
	"./dev3.mp4": 6997,
	"./dev4.mp4": 4342,
	"./dev5.mp4": 4763,
	"./dev6.mp4": 1108,
	"./th3d.mp4": 9344,
	"./thdev.mp4": 2132,
	"./thvid.mp4": 1580
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6658;